/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDistribute = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m15.586 4-1.293-1.293 1.414-1.414L19.414 5l-3.707 3.707-1.414-1.414L15.586 6H12v5h6.195l-1.293-1.293 1.414-1.414L22.025 12l-3.707 3.707-1.415-1.414L18.195 13H12v5h3.586l-1.293-1.293 1.414-1.414L19.414 19l-3.707 3.707-1.414-1.414L15.586 20H10v-7H7.83A3.001 3.001 0 0 1 2 12a3 3 0 0 1 5.83-1H10V4zM4 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDistribute as Distribute };
